import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function Section({
  children,
  className = '',
  id,
  delay = 0
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className={`w-full max-w-3xl mx-auto px-6 py-12 md:py-16 ${className}`} data-id="element-144">
      {children}
    </motion.section>;
}